import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const ChangePassword: React.FC<IconProps> = () => {
  return (
    <svg width="150" height="151" viewBox="0 0 548 551" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M274 548C425.326 548 548 425.326 548 274C548 122.674 425.326 0 274 0C122.674 0 0 122.674 0 274C0 425.326 122.674 548 274 548Z" fill="#EAECF0" />
      <g filter="url(#filter0_d_9573_32556)">
        <mask id="mask0_9573_32556" maskUnits="userSpaceOnUse" x="0" y="0" width="548" height="548">
          <path
            d="M274 548C425.326 548 548 425.326 548 274C548 122.674 425.326 0 274 0C122.674 0 0 122.674 0 274C0 425.326 122.674 548 274 548Z"
            fill="url(#paint0_linear_9573_32556)"
          />
        </mask>
        <g mask="url(#mask0_9573_32556)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M99 337.036C99 331.432 101.351 326.085 105.482 322.297L268.186 173.076C273.627 168.087 282.007 168.179 287.337 173.287L442.839 322.336C446.775 326.108 449 331.324 449 336.775V552.579C449 560.864 442.284 567.579 434 567.579H114C105.716 567.579 99 560.864 99 552.579V337.036Z"
            fill="#C7CED4"
          />
          <g filter="url(#filter1_d_9573_32556)">
            <rect x="123.953" y="203.587" width="300.096" height="290.569" rx="4" fill="white" />
          </g>
          <mask id="mask1_9573_32556" maskUnits="userSpaceOnUse" x="99" y="169" width="350" height="399">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M99 337.036C99 331.432 101.351 326.085 105.482 322.296L268.186 173.076C273.627 168.087 282.007 168.179 287.337 173.287L442.839 322.336C446.775 326.108 449 331.323 449 336.775V552.579C449 560.864 442.284 567.579 434 567.579H114C105.716 567.579 99 560.864 99 552.579V337.036Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_9573_32556)">
            <g filter="url(#filter2_d_9573_32556)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M99 328.24L268.154 450.13C271.645 452.646 276.355 452.646 279.846 450.13L449 328.24V557.578C449 563.101 444.523 567.578 439 567.578H109C103.477 567.578 99 563.101 99 557.578V328.24Z"
                fill="#FDFEFF"
              />
            </g>
            <g filter="url(#filter3_d_9573_32556)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M268.154 445.687C271.645 443.171 276.355 443.171 279.846 445.687L449 567.577H99L268.154 445.687Z"
                fill="white"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        d="M193.922 348.338H199.407L198.967 338.128L207.415 343.453L210.138 339.209L200.849 334.284L210.138 329.399L207.415 325.155L198.967 330.48L199.407 320.271H193.922L194.362 330.521L185.874 325.155L183.151 329.399L192.44 334.284L183.151 339.209L185.874 343.453L194.362 338.088L193.922 348.338ZM232.6 348.338H238.085L237.645 338.128L246.093 343.453L248.815 339.209L239.526 334.284L248.815 329.399L246.093 325.155L237.645 330.48L238.085 320.271H232.6L233.04 330.521L224.552 325.155L221.829 329.399L231.118 334.284L221.829 339.209L224.552 343.453L233.04 338.088L232.6 348.338ZM271.277 348.338H276.763L276.322 338.128L284.771 343.453L287.493 339.209L278.204 334.284L287.493 329.399L284.771 325.155L276.322 330.48L276.763 320.271H271.277L271.718 330.521L263.229 325.155L260.507 329.399L269.796 334.284L260.507 339.209L263.229 343.453L271.718 338.088L271.277 348.338ZM309.955 348.338H315.44L315 338.128L323.448 343.453L326.171 339.209L316.882 334.284L326.171 329.399L323.448 325.155L315 330.48L315.44 320.271H309.955L310.396 330.521L301.907 325.155L299.185 329.399L308.474 334.284L299.185 339.209L301.907 343.453L310.396 338.088L309.955 348.338ZM348.633 348.338H354.118L353.678 338.128L362.126 343.453L364.849 339.209L355.56 334.284L364.849 329.399L362.126 325.155L353.678 330.48L354.118 320.271H348.633L349.073 330.521L340.585 325.155L337.862 329.399L347.151 334.284L337.862 339.209L340.585 343.453L349.073 338.088L348.633 348.338Z"
        fill="#98A2B3"
      />
      <path
        d="M258 253.334H282V248C282 245.778 281.222 243.889 279.667 242.334C278.111 240.778 276.222 240 274 240C271.778 240 269.889 240.778 268.333 242.334C266.778 243.889 266 245.778 266 248H260.667C260.667 244.311 261.967 241.167 264.568 238.566C267.169 235.965 270.313 234.665 274 234.667C277.689 234.667 280.834 235.967 283.435 238.568C286.035 241.169 287.335 244.313 287.333 248V253.334H290C291.467 253.334 292.723 253.856 293.768 254.902C294.813 255.947 295.335 257.202 295.333 258.667V285.334C295.333 286.8 294.811 288.056 293.765 289.102C292.72 290.147 291.465 290.669 290 290.667H258C256.533 290.667 255.277 290.144 254.232 289.099C253.187 288.054 252.665 286.799 252.667 285.334V258.667C252.667 257.2 253.189 255.944 254.235 254.899C255.28 253.854 256.535 253.332 258 253.334ZM274 277.334C275.467 277.334 276.723 276.811 277.768 275.766C278.813 274.72 279.335 273.465 279.333 272C279.333 270.534 278.811 269.278 277.765 268.232C276.72 267.187 275.465 266.665 274 266.667C272.533 266.667 271.277 267.19 270.232 268.235C269.187 269.28 268.665 270.535 268.667 272C268.667 273.467 269.189 274.723 270.235 275.768C271.28 276.814 272.535 277.335 274 277.334Z"
        fill="#98A2B3"
      />
      <path
        d="M193.627 116.906C201.697 116.906 208.24 110.364 208.24 102.293C208.24 94.2223 201.697 87.6797 193.627 87.6797C185.556 87.6797 179.013 94.2223 179.013 102.293C179.013 110.364 185.556 116.906 193.627 116.906Z"
        fill="white"
      />
      <path
        d="M274.001 116.907C282.071 116.907 288.614 110.365 288.614 102.294C288.614 94.2233 282.071 87.6807 274.001 87.6807C265.93 87.6807 259.387 94.2233 259.387 102.294C259.387 110.365 265.93 116.907 274.001 116.907Z"
        fill="#98A2B3"
      />
      <path
        d="M354.374 116.907C362.444 116.907 368.987 110.365 368.987 102.294C368.987 94.2233 362.444 87.6807 354.374 87.6807C346.303 87.6807 339.76 94.2233 339.76 102.294C339.76 110.365 346.303 116.907 354.374 116.907Z"
        fill="white"
      />
      <defs>
        <filter id="filter0_d_9573_32556" x="93" y="160.395" width="362" height="390.605" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9573_32556" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9573_32556" result="shape" />
        </filter>
        <filter
          id="filter1_d_9573_32556"
          x="115.953"
          y="202.587"
          width="316.096"
          height="306.569"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_9573_32556" />
          <feOffset dy="7" />
          <feGaussianBlur stdDeviation="6" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9573_32556" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9573_32556" result="shape" />
        </filter>
        <filter id="filter2_d_9573_32556" x="82" y="308.24" width="384" height="273.338" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="8.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.108708 0 0 0 0 0.237823 0 0 0 0 0.391768 0 0 0 0.0690104 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9573_32556" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9573_32556" result="shape" />
        </filter>
        <filter id="filter3_d_9573_32556" x="92" y="433.8" width="364" height="137.777" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="3.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.252325 0 0 0 0 0.423517 0 0 0 0 0.627631 0 0 0 0.02607 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9573_32556" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9573_32556" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_9573_32556" x1="274" y1="0" x2="274" y2="548" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E3ECFA" />
          <stop offset="1" stopColor="#DAE7FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ChangePassword;
